export const sorterMap: {
    key?: string;
    value: string;
    label: string;
}[] = [
        { key: "asc", value: "", label: "오름차순" },
        { key: "desc", value: "-", label: "내림차순" },
    ];
